<div class="range-bar-wrapper d-flex flex-column justify-content-start">
  <div class="price-range d-flex flex-row justify-content-between" [ngClass]="[!hasBigFont ? 'font-8' : 'font-12']">
    <span [tooltip]="'low_range_tooltip'|translate" containerClass="tooltipClass" class="cursor-pointer title-text">{{
      rangeData.unit}}{{
      convertNumToCurr(rangeData.minPrice)}}</span>
    <span [tooltip]="'high_range_tooltip'|translate" containerClass="tooltipClass" class="cursor-pointer title-text">{{
      rangeData.unit}}{{
      convertNumToCurr(rangeData.maxPrice)}}</span>
  </div>
  <div class="bar-wrapper">
    <div class="bar"></div>
  </div>
  <div class="marker-wrapper d-flex flex-column justify-content-center align-items-end"
    [ngStyle]="{ width: getWidth() }">
    <div class="marker-content d-flex flex-column justify-content-center align-items-center">
      <img src="assets/images/svg-icons/range-bar-marker.svg" alt="" class="marker" />
      <span class="slider-value" [ngClass]="[!hasBigFont ? 'font-10' : 'font-16']">{{ rangeData.unit }}{{
        convertNumToCurr(rangeData.currentPrice) }}</span>
    </div>
  </div>
</div>